/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CompleteOrderExaminationApiModel { 
    examinationTypeId: number;
    result?: string | null;
    examinationDate: string;
    externalIdentification?: string | null;
}

